// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zCHil {\n  max-width: 660px;\n}\n\n@media (max-width: 1020px) {\n  .ayEO9 {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n  }\n\n  ._60-KS {\n    width: 100%;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n  }\n\n  .gnKrc {\n    margin-top: var(--spacing-md);\n  }\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subtitle": "zCHil",
	"headerContainer": "ayEO9",
	"headerSection": "_60-KS",
	"headerSectionRight": "gnKrc"
};
export default ___CSS_LOADER_EXPORT___;
